import CustomPaletteProvider from './PaletteProvider';

export default {
  __init__: [ 'paletteProvider' ],
  paletteProvider: [ 'type', CustomPaletteProvider ],
};
